(function () {
    'use strict';

    angular.module('processModule')
        .controller('areas-root-view.controller', areasRootViewController);

    areasRootViewController.$inject = ['$scope', 'routeService', '$sce'];
    function areasRootViewController($stateParams, routeService, $sce) {
        var vm = this;
        vm.initialize = initialize;
        vm.areaId = $stateParams.areaId;
        vm.areasRootViewIframe = '';


        initialize();

        function initialize() {
            vm.areasRootViewIframe = $sce.trustAsResourceUrl(routeService.getBaseRouteProcess() + 'home/details?isOnlyApproved=true&isFrontend=true');
        }
    }
})();

